var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-menu',{staticClass:"towerList",attrs:{"mode":"inline","inlineIndent":12}},[_c('RecycleScroller',{ref:"scroller",staticClass:"scroller",attrs:{"items":_vm.towers,"item-size":32,"key-field":"name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return _c('li',{key:item.name,staticClass:"ant-menu-item",class:{ 
                'ant-menu-item-selected': _vm.$route.params.id == item.name 
            },on:{"click":function($event){return _vm.selectTower(item.name)}}},[_vm._v(_vm._s(item.title))])}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }